// Unlike everything else .btn does not have separate js class (js-btn)

import PaperRipple from 'paper-ripple';
import $ from 'jquery';

export default {
  class: 'btn',
  selector: '.btn',
  dom: {
    $buttons: null
  },
  initRipple(selector = this.selector, rippleLayerSelector = null) {
    const $buttons = $(selector);

    if (!$buttons.length) {
      return;
    }

    $buttons.each(function() {
      // New PaperRipple for the button
      const ripple = new PaperRipple();
      let rippleLayer;
      // If we want to attach ripple to another layer
      if(rippleLayerSelector) {
        rippleLayer = this.querySelector(rippleLayerSelector);
      }

      if(rippleLayer) {
        rippleLayer.appendChild(ripple.$);
      } else {
        this.appendChild(ripple.$);
      }


      // Subscribing to 'mousedown' and 'mouseup' button events to activate ripple effect
      // when a user clicks on the button.
      this.addEventListener('mousedown', function(ev) {
        ripple.downAction(ev);
      });

      this.addEventListener('mouseup', function() {
        ripple.upAction();
      });
    });
  }
}
